<template lang="pug">
  .refresh-block.iconfont.iconshuaxin(@click.stop="refreshData")
</template>
<script>
export default {
  name: 'RefreshBlock',
  methods: {
    refreshData () {
      this.$emit('refreshData')
    }
  }
}
</script>
<style lang="scss" scoped>
.refresh-block {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: rgba(255, 255, 255, 0.66);
  width: 50px !important;
  z-index: 100;
  height: 50px !important;
  border-radius: 50%;
  font-size: 40px;
  color: #dacece;
  line-height: 50px;
  text-align: center;
  transition: All 0.4s ease-in-out;
  &:hover {
    color: #fff;
    cursor: pointer;
    transform: rotate(360deg);
  }
}
</style>
